import { InjectionToken } from '@angular/core';

export interface SeahorseMenuItem {
  label: string;
  icon?: string;
  iconUrl?: string;
  route?: string;
  items?: SeahorseMenuItem[];
  placement?: 'top' | 'bottom';
  permissions?: string;
  feature?: string;
  order?: number;
  isSecondary?: boolean;
}

export const SIDEBAR_MENU = new InjectionToken<SeahorseMenuItem[]>(
  'Sidebar configuration'
);

export const SIDEBAR_LOCAL_STORAGE = {
  isOpen: 'sidebar:isOpen',
};
